import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

function ProtectedAdminRoute({ children }) {
    const user = useSelector(state => state.auth.user);
    const location = useLocation();
    if (!user && user?.profile.default_role !== 'Admin') {
        sessionStorage.setItem('from', location.pathname);
        return <Navigate to={`${process.env.PUBLIC_URL}/login`} />;
    }

    return children;
}

export default ProtectedAdminRoute
